<template lang="pug">
#tabela-gestao-contrato-originacao-empresa
    .tabela-gestao-contrato-originacao__tabela
        el-table(
            :key="listagemTableKey('gestao-py', tabelaData, paginacao.pagina + 1)",
            :data='tabelaData',
            v-loading='carregando',
            stripe,
            :default-sort='{ prop: "date", order: "descending" }',
            @sort-change='sortChangeRequest',
            style='width: 100%',
            ref='multipleTable',
            @selection-change='handleSelectionChange'
        )
            el-table-column(
                type='selection',
                :selectable='camposSelecionaveis',
                v-if='removendo',
                align='center',
                width='45'
            )

            el-table-column(
                prop='numeroContrato',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.numeroContrato")',
                align='left',
                sortable
            )
            el-table-column(
                v-if='isUsuarioLDC',
                prop='subTradingNome',
                width='200',
                label='Trading',
                sortable
            )
            el-table-column(
                prop='subEmpresaNome',
                width='370',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.fornecedor")',
                sortable
            )
            el-table-column(
                prop='materialNome',
                width='200',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.cultura")',
                sortable
            )
            el-table-column(
                prop='safraNome',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.safra")',
                sortable
            )
            el-table-column(
                prop='volumeContratado',
                width='200',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.volumeContratado")',
                sortable='custom'
            )
                .template(slot-scope='scope')
                    span {{ scope.row.volumeContratado + ' t' }}
            el-table-column(
                prop='dataContrato',
                width='200',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.dataContrato")',
                sortable
            )
            el-table-column(
                prop='statusEmpresa',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.statusEmpresa")',
                sortable,
                align='left'
            )
                .template(slot-scope='scope')
                    .status-processamento {{ scope.row.statusEmpresa }}
                    .status-processamento__dias(v-if='scope.row.dataDias')
                        i.mdi.mdi-clock-outline
                        | {{ scope.row.dataDias }} {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.' + (scope.row.dataDias > 1 ? 'dias' : 'dia')) }}

            el-table-column(label='', align='center', width='45')
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='visualizarProcessamento(scope.row.numeroContrato)'
                            )
                                | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.visualizarContrato') }}
                            el-dropdown-item(
                                v-if='scope.row.statusEmpresaCodigo === "NAO_VISUALIZADO" || scope.row.statusEmpresaCodigo === "VISUALIZADO"',
                                @click.native='editarContrato(scope.row.numeroContrato)'
                            )
                                i.mdi.mdi-square-edit-outline
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.editarContrato') }}
                            el-dropdown-item(
                                v-if='scope.row.statusEmpresaCodigo !== "ARQUIVADO" && scope.row.statusEmpresaCodigo !== "CONCLUIDO"',
                                @click.native='arquivarContrato(scope.row.id)'
                            )
                                i.mdi.mdi-archive
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.arquivar') }}
                            el-dropdown-item(
                                v-if='scope.row.statusEmpresaCodigo === "CONCLUIDO"',
                                @click.native='verInforme(scope.row.id)'
                            )
                                i.mdi.mdi-file-download-outline
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.verInforme') }}
                            el-dropdown-item(
                                @click.native='removerContrato(scope.row)',
                                v-if='codigosRemover[scope.row.statusEmpresaCodigo]'
                            )
                                i.mdi.mdi-trash-can-outline
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.removerContrato') }}
            template(slot='empty')
                el-empty(
                    :description='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.semDados")'
                )

    .tabela-gestao-contrato-originacao__paginacao
        div
            span.pagina {{ paginacao.total }} {{ paginacao.total > 1 ? this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.contratos') : this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.contrato') }}
            span.pagina.espacamento-totalizador {{ formatNumber(totalizador) }} {{ totalizador > 1 ? this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.totalizadorToneladas') : this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.totalizadorTonelada') }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )
</template>

<script>
import ModalDetalheAnalise from '@/components/contratosOriginacao/ModalDetalheAnalise.vue';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import { mapGetters } from 'vuex';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import formatters from '@/utils/formatters';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'TabelaGestaoContratoOriginacaoEmpresa',
    components: {
        ModalDetalheAnalise
    },
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        },
        totalizador: {
            type: Number,
            required: false
        },
        removendo: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            notificacaoExportarRelatorio: null,
            codigosRemover: {
                NAO_VISUALIZADO: 'NAO_VISUALIZADO',
                CONCLUIDO: 'CONCLUIDO'
            },
            contratosSelecionados: [],
            numeroContratoSelecionado: '',
            ambientes: AmbientesEmpresas
        };
    },
    mounted() { },

    computed: {
        ...mapGetters(['usuarioLogado']),
        isUsuarioLDC() {
            return this.usuarioLogado?.isLDC === true;
        }
    },
    methods: {
        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },
        sortChangeRequest(column) {
            this.$emit('ordenarTabela', column);
        },
        visualizarProcessamento(numeroContrato) {
            this.$router.push({
                name: 'VisualizarContratoOriginacaoEmpresaPY',
                params: { id: numeroContrato }
            });
        },
        editarContrato(numeroContrato) {
            this.$router.push({
                name: 'EditarContratoOriginacaoEmpresaPY',
                params: { id: numeroContrato }
            });
        },
        async exportarRelatorioContrato(numeroContrato) {
            try {
                await connect();
            } catch {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.erroDownloadPdf'
                    )
                );
                return;
            }

            if (this.usuarioLogado) {
                try {
                    subscribe(
                        `${this.usuarioLogado.idKeyCloack}/empresa/relatorio/exportado`,
                        response => {
                            if (response) {
                                const linkSource = `data:application/pdf;base64,${response}`;
                                const link = document.createElement('a');
                                const fileName = this.$t(
                                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.exportarRelatorioFilename'
                                );
                                link.href = linkSource;
                                link.download = fileName;
                                document.body.append(link);
                                link.click();
                                link.remove();
                            } else {
                                this.$notify.error(
                                    this.$t(
                                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.erroExportarRelatorio'
                                    )
                                );
                            }
                            if (this.notificacaoExportarRelatorio) {
                                this.notificacaoExportarRelatorio.close();
                            }
                            disconnect();
                        }
                    );

                    ContratoOriginacaoService.exportarRelatorioContratoEmpresaPY(
                        numeroContrato
                    );

                    this.notificacaoExportarRelatorio = this.$notify({
                        message:
                            '<i class="el-icon-loading" style="font-size: 20px; color: #043c5a;"></i>' +
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.downloadEmProcessamento'
                            ),
                        duration: 600000,
                        dangerouslyUseHTMLString: true,
                        showClose: false
                    });
                } catch (error) {
                    this.$notify.error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.erroDownloadPdf'
                        )
                    );
                    if (this.notificacaoExportarRelatorio) {
                        this.notificacaoExportarRelatorio.close();
                    }
                    disconnect();
                }
            } else {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.usuarioDeslogado'
                    )
                );
                disconnect();
            }
        },
        async removerContrato(contratoOriginacao) {
            const result = await this.$messageBox.confirm(
                this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.confirmarRemocaoContrato'
                ) +
                contratoOriginacao.numeroContrato +
                '?',
                this.$t('mensagens.comuns.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result) {
                this.$emit('removerContrato', contratoOriginacao.id);
            }
        },
        async arquivarContrato(idContratoOriginacao) {
            const result = await this.$messageBox.confirm(
                this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.tabelaGestao.confirmarArquivamentoContrato'
                ),
                this.$t('mensagens.comuns.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result) {
                this.$emit('arquivarContrato', idContratoOriginacao);
            }
        },
        limparRemocao() {
            this.$refs.multipleTable.clearSelection();
        },
        handleSelectionChange(dadosContrato) {
            this.contratosSelecionados = dadosContrato;
            const idsContratosOriginacao = this.contratosSelecionados.map(
                contrato => contrato.id
            );

            this.emiteRemoverContratoLote(idsContratosOriginacao);
        },
        emiteRemoverContratoLote(idsContratosOriginacao) {
            this.$emit('removerContratoLote', idsContratosOriginacao);
        },
        camposSelecionaveis(row, index) {
            const selecionavel =
                row.statusEmpresaCodigo === 'CONCLUIDO' ||
                row.statusEmpresaCodigo === 'NAO_VISUALIZADO';
            return selecionavel;
        },
        formatNumber(number, decimalPlaces) {
            if (number < 1) {
                return 0;
            }
            return formatters.formatNumber(number, decimalPlaces);
        },

        async verInforme(numeroContrato) {
            await ContratoOriginacaoService.downloadInformeContratoOriginacao(numeroContrato);
        }
    }
};
</script>
<style lang="scss">
#tabela-gestao-contrato-originacao-empresa {
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;

        th.el-table__cell>.cell {
            font-weight: bold !important;
            font-size: 13px !important;
            font-family: 'SF Pro Display', sans-serif !important;
        }

        thead.has-gutter {
            height: 67px;

            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }

    .el-table__cell {
        font-size: 12px;
    }

    .is-leaf {
        font-size: 13px;
    }

    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }

    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }

    .tabela-gestao-icone {
        i {
            font-size: 23px;
            cursor: pointer;
        }
    }

    .status-processamento__dias {
        font-size: 12px;
        font-style: italic;

        i {
            margin-right: 2px;
        }

        .texto-alert {
            columns: #f88342;
        }
    }

    .espacamento-totalizador {
        margin-left: 20px;
    }
}

.el-message-box__btns {
    display: flex;
    justify-content: space-between;
}
</style>
